import React, { useState, useEffect } from "react";

const AnswerPill = ({ text, selected, onToggle }) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(selected);
  }, [selected]);

  const handleClick = () => {
    setChecked(!checked);
    onToggle(!checked);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-pressed={checked}
      aria-label={`${text}, ${checked ? "selected" : "not selected"}`}
      className={`px-6 py-3 rounded-full text-base font-medium transition-all duration-200 ${
        checked
          ? "bg-nyc-green text-white shadow-md"
          : "bg-unselected-bg text-white hover:bg-border-strong"
      }`}
    >
      {text}
    </button>
  );
};

export default AnswerPill;
